export default "__VITE_ASSET__BFwGwBVn__"